module.exports = __webpack_public_path__ + "60feddb603e0f9b8912a809caa55b730.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/inner-circle.png
// module id = 6aZc
// module chunks = 0